<template>
  <div id="create-version">
    <div class="panel panel-default">
      <div class="panel-heading">
        <h2>
          <back-button :button-type-class="'btn-default'">Previous</back-button>
          Create Inbox
        </h2>
      </div>
      <div class="panel-body">
        <div class="col-md-12">
          <p>
            Please enter a title for your project. This will act as an identifier on your dashboard,
            and it can always be edited later from the Administration page of the platform.
          </p>
        </div>
        <div class="col-md-6 col-sm-12">
          <form>
            <div class="form-group">
              <label for="name">Name</label>
              <input
                id="name"
                class="form-control"
                type="text"
                v-model="versionName"
                data-cy="new-version-name"
              />
            </div>
            <div class="clearfix"></div>
            <button
              @click.prevent="handleCreate"
              :disabled="versionName.length === 0"
              class="btn mat btn-primary"
              data-cy="create-version-btn"
            >
              Create
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapActions } from 'vuex';
  export default {
    name: 'NewVersion',

    data: () => ({
      versionName: '',
      isActive: 0,
    }),

    methods: {
      ...mapActions(['SET_MILESTONE']),
      ...mapActions('versions', ['createVersion']),

      async handleCreate() {
        const newVersion = await this.createVersion({
          versionName: this.versionName,
          isActive: this.isActive,
        });

        this.SET_MILESTONE({
          message: 'Create a New Project',
          tooltipDesc: this.tooltips.milestones['2'],
          timeout: 8000,
          milestoneKey: 2,
        });

        this.$router.push({ name: 'skills', params: { resourceKey: newVersion.versionKey } });
      },
    },
  };
</script>
